import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { FdrsClientService } from 'src/app/service/fdrs-client.service';
import { RpcClientService } from 'src/app/service/rpc-client.service';
import * as environmentUrl from 'src/environments/environment';


@Component({
  selector: 'app-postrepairprocedure',
  templateUrl: './postrepairprocedure.component.html',
  styleUrls: ['./postrepairprocedure.component.scss']
})
export class PostrepairprocedureComponent implements OnInit {
  ptsUrl = environmentUrl.environment.ptsUrl;
  public temp: any = [];
  public sessionId: any;
  public vinNumber: any;
  public gIdArray: any = [];
  public btnName = 'REPAIR AND POST REPAIR CANDIDATES';
  public userName: string = '';
  public userType: string = '';
  public language: string = '';
  public country: string = '';
  public userTypeID: number = 0;
  public countryThree: string = '';
  isEnableService = false;
  ptsEngineServiceResponseObj: any;
  globalServices: any = [];
  globalManagedRes: any;
  FDRSStatusLoader: boolean = false;
  webSocketHandshake: boolean = false;
  fdrsSubscription: Subscription = new Subscription;
  tokenSubscription: Subscription = new Subscription;
  serviceNameListSubscription: Subscription = new Subscription;
  gIdPostRepairSubscription: Subscription = new Subscription;
  postRepairSubscription: Subscription = new Subscription;
  viewCompletePostRepair: boolean = false;
  constructor(private service: ApifirstService, private router: Router, private modalService: NgbModal,private rpcClient: RpcClientService, private fdrsClient: FdrsClientService) { }

  ngOnInit(): void {
    this.service.setShowWhatsNew(false);
    this.sessionId = localStorage.getItem("sessionID");
    //update page number
    const requ = {
      "sessionId": this.sessionId,
      "pageid": "19"
    }
    this.service.updatePage(requ).subscribe(data => { })

    this.tokenSubscription = this.service.tokenObj.subscribe((data) => {
      let token: any = data;
      this.vinNumber = token.vin;
      this.userName = token.username;
      this.userType = token.userType;
      this.country = token.country;
      this.language = token.language;
      if (Object.keys(data).length !== 0) {
        if (this.userType == 'FORD_INTERNAL') {
          this.userTypeID = 1
        } else if (this.userType == 'PTS_DEALER') {
          this.userTypeID = 3;
        } else if (this.userType == 'PTS_AFTERMARKET') {
          this.userTypeID = 2;
        }
    }
    })

    this.serviceNameListSubscription = this.service.serviceNameListservice.subscribe((data) => {
      this.globalServices = data;
      for (let obj of this.globalServices) {
        if (obj.serviceName=="PTS Service") {
          this.ptsEngineServiceResponseObj = obj;
        }
      }
    })

    this.gIdPostRepairSubscription = this.service.storeGidPostRepair.subscribe((data) => {
      this.gIdArray = data;
    })

    this.postRepairSubscription = this.service.postRepairObj.subscribe((data) => {
      this.temp = data;
      this.checkAbortStatus(this.temp)
      if (this.gIdArray.length == this.temp.length) {
        this.btnName = "Continue";
      } else {
        this.btnName = "REPAIR AND POST REPAIR CANDIDATES";
      }
    })
  }

  checkAbortStatus(result: any) {
    for(let obj of result) {
      if(obj.result.state == 'Aborted') {
        let Gid = obj.procRef.procUidRef;
        this.gIdArray = this.gIdArray.filter((value: any) => value !== Gid);
        this.service.storeGidPostRepair.next(this.gIdArray);
      }
    }
  }

  navigateToRepQua() {
    this.viewCompletePostRepair = true;
    this.service.isRepairProcedure.next(false);
    if (this.btnName === 'Continue') {
      this.service.isPostRepairProcedure.next(false);
    } else {
      this.service.isPostRepairProcedure.next(true);
    }
    this.service.control.next(true);
    this.service.resumeRVC.next(false);
    this.service.repairPostRepairBtnClickForPostRepair(this.sessionId).subscribe((data) => {
      this.viewCompletePostRepair = false;
      console.log('repair post repair btn click:', data);
      this.router.navigate(['/repair']);
    })
  }

  navigateToTest(id: string, kind: string, uidRef: string, title: string, content: any, networkTestStatus: any) {
    //Count test button click to enable or disable Go button in repair qualification page.
    this.service.candidateId.next(id);
    this.service.candidateUidRef.next(uidRef);
    let postRepairObj = {
      'id': id,
      'screen': 'postRepair',
      'kind': kind
    }
    this.service.navigatetoPreviousScreen.next(postRepairObj);
    if (kind == 'OTX-CANDIDATE' || kind == 'OTX-SERVFUNC-CANDIDATE' || kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
      let selectedRecord = [{
        "rating": 5,
        "procedure": title,
        "state": 'Untested'
      }]
      this.service.selectedDiagnosticProcedureData$.next(selectedRecord);
      this.service.navigatePreviousScreen.next('postRepairProcedure');
      this.getFDRSStatus(networkTestStatus,content,id);
    } else if (kind == 'PINPOINT-CANDIDATE' || kind == 'GENERAL-INFORMATION-CANDIDATE' || kind == 'REPAIR-INFO-CANDIDATE') {
      const req = {
        "sessionId": this.sessionId,
        "pageid": "14"
      }
      this.service.updatePage(req).subscribe(data => { })
      this.router.navigate(['/view']);
    } else if (kind == 'TSB-CANDIDATE') {
      const req = {
        "sessionId": this.sessionId,
        "pageid": "14"
      }
      this.service.getGlobalManagedServicesDetails(this.ptsEngineServiceResponseObj.id).subscribe((data) => {
        this.globalManagedRes = data;
        if (!this.globalManagedRes) {
          this.isEnableService = true;
        } else {
          this.isEnableService = false;
        }
        if (this.isEnableService) {
          this.service.updatePage(req).subscribe(data => { })
          var procUidref = id;
          procUidref = procUidref.substring(4);
          procUidref = procUidref.replace("/", "-");
          if (procUidref == "68-2013") {
            procUidref = "068/2013";
          }
          console.log("TSB-procUid", procUidref);
          const path = this.ptsUrl+ "Transport?link=001&param=" + procUidref;
          window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
          this.router.navigate(['/view']);
        } else {
          this.service.selectedGlobalServices.next('PTS Service');
          this.router.navigate(['/globalServiceEnabled']);
        }
      })
    } else if (kind == 'ETIS-CANDIDATE') {
      const req = {
        "sessionId": this.sessionId,
        "pageid": "19"
      }
      this.service.getGlobalManagedServicesDetails(this.ptsEngineServiceResponseObj.id).subscribe((data) => {
        this.globalManagedRes = data;
        if (!this.globalManagedRes) {
          this.isEnableService = true;
        } else {
          this.isEnableService = false;
        }
        if (this.isEnableService) {
          this.service.updatePage(req).subscribe(data => { })
          // New Component Implementation Not Known
          const path = this.ptsUrl + "transport/?link=700&params=" + this.vinNumber + "&uid=" + uidRef + "&procuid=" + id;
          window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
          for (let candidate of this.temp) {
            if (candidate.procRef.procUidRef == id) {
              console.log('********', candidate);
              candidate.result.state = 'Viewed';
              break;
            }
          }
          if (!this.gIdArray.includes(id)) {
            this.gIdArray.push(id);
            this.service.storeGidPostRepair.next(this.gIdArray);
          }
          this.service.postRepairObj.next(this.temp);
          let req1 = {
            "sessionId": this.sessionId,
            "faultFoundValue": "false",
            "faultComponentGNumber": "",
            "pageState": "POST_REPAIR",
            "vin": this.vinNumber,
            "userId": this.userName,
            "userType": this.userType,
            "languageCode": this.language,
            "countryCode": this.country
          }
          this.viewCompletePostRepair = true;
          this.service.postRepairTestBtnClick(id, this.sessionId).subscribe((data) => {
            this.service.noFaultButtonClick(req1).subscribe((data) => {
              this.viewCompletePostRepair = false;
              console.log("No fault Btn Repair:", data);
            })
          })
        } else {
          this.service.selectedGlobalServices.next('PTS Service');
          this.router.navigate(['/globalServiceEnabled']);
        }
      })
    } else {
      // Error Component
      this.router.navigate(['/errorCandidate']);
    }
  }

  getFDRSStatus(networkTestInfo: string, content: string, id: string) {
    localStorage.setItem("component", "fromPostRepair");
    this.FDRSStatusLoader = true;
    this.service.getFDRSStatusInDiagnostic.next('test');
    if (localStorage.getItem("connectionState") == '1') {
      this.rpcClient.checkFDRSConnectionStatus();
    } else {
      this.fdrsClient.initFdrsClient("");
    }
    this.fdrsSubscription = this.service.getFDRSStatusInDiagnostic.subscribe((data) => {
      if (data == 'true') {
        this.FDRSStatusLoader = false;
        this.service.isNetworkTestNeeded(this.vinNumber,this.userTypeID,this.countryThree).subscribe((data) => {
          if (data.status) {
            localStorage.setItem("lastVisitedScreen", "fromPostRepair");
            this.modalService.open(networkTestInfo, { centered: true });
          } else {
            const req = {
              "sessionId": this.sessionId,
              "pageid": "14"
            }
            this.service.updatePage(req).subscribe(data => { })
            if (!this.gIdArray.includes(id)) {
              this.gIdArray.push(id);
              this.service.storeGidPostRepair.next(this.gIdArray);
            }
            localStorage.setItem("lastVisitedScreen", "");
            this.router.navigate(['/otxCandidate']);
          }
        });
      } else if (data == 'false' && localStorage.getItem("connectionState") == '1' && !this.webSocketHandshake) {
        this.rpcClient.checkWebSocketConnectionStatus();
        this.webSocketHandshake = true;
      } else if (data == 'false' && localStorage.getItem("connectionState") == '1' && this.webSocketHandshake) {
        this.FDRSStatusLoader = false;
        this.webSocketHandshake = false;
        this.modalService.open(content, { centered: true });
        this.fdrsSubscription.unsubscribe();
      } else if (data == 'false' && localStorage.getItem("connectionState") !== '1' ) {
        this.FDRSStatusLoader = false;
        this.modalService.open(content, { centered: true });
        this.fdrsSubscription.unsubscribe();
      }
    })
  }

  navigateToNetworkTest() {
    localStorage.setItem("component", "fromNetworkTest");
    this.router.navigate(['/closeCanceldiagnosis']);
  }

  ngOnDestroy() {
    this.fdrsSubscription.unsubscribe();
    this.tokenSubscription.unsubscribe();
    this.serviceNameListSubscription.unsubscribe();
    this.gIdPostRepairSubscription.unsubscribe();
    this.postRepairSubscription.unsubscribe();
  }
}
